import React from 'react';
import { motion } from 'framer-motion';
import './MainContent.css';

const AboutSection = () => {
  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3
      }
    }
  };
  
  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.5
      }
    }
  };
  
  return (
    <section id="about" className="about-section">
      <div className="section-background">
        <div className="diagonal-line"></div>
        <div className="glow-orb orb-1"></div>
        <div className="glow-orb orb-2"></div>
      </div>
      
      <div className="section-container">
        <motion.div 
          className="section-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="section-title">About <span className="gradient-text">WiggaChain</span></h2>
          <div className="title-underline"></div>
        </motion.div>
        
        <div className="about-content">
          <motion.div 
            className="about-text"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h3 className="about-subtitle">We Make Other Blockchains Look Broke AF</h3>
            <p>
              WiggaChain ain't just another blockchain. We're the goddamn financial revolution these crypto 
              nerds have been jerking off to since 2009. While other projects are busy sucking VC dick, 
              we're building a money printer that even the Fed is jealous of.
            </p>
            <p>
              Created by an anonymous team of quantum physicists who got bored making billions in hedge funds, 
              WiggaChain uses our revolutionary Proof-of-Wigga consensus that makes Ethereum look like it was 
              built by kindergartners with crayons. Our blockchain solves problems you don't even know exist yet.
            </p>
            
            <div className="key-features">
              <motion.div 
                className="feature-list"
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
              >
                <motion.div className="feature-item" variants={itemVariants}>
                  <div className="feature-icon">🚀</div>
                  <div className="feature-text">
                    <h4>QUANTUM-SPEED TRANSACTIONS</h4>
                    <p>0.0000069 second finality. Literally faster than light, breaking multiple laws of physics. NASA is investigating us.</p>
                  </div>
                </motion.div>
                
                <motion.div className="feature-item" variants={itemVariants}>
                  <div className="feature-icon">💸</div>
                  <div className="feature-text">
                    <h4>INFINITE TPS</h4>
                    <p>Our proprietary scaling solution can handle every transaction on earth simultaneously while running on a Raspberry Pi.</p>
                  </div>
                </motion.div>
                
                <motion.div className="feature-item" variants={itemVariants}>
                  <div className="feature-icon">🧠</div>
                  <div className="feature-text">
                    <h4>SENTIENT AI INTEGRATION</h4>
                    <p>Our blockchain has feelings and gets offended if you sell. It also predicts price movements with 420% accuracy.</p>
                  </div>
                </motion.div>
                
                <motion.div className="feature-item" variants={itemVariants}>
                  <div className="feature-icon">🔮</div>
                  <div className="feature-text">
                    <h4>PRICE ONLY GOES UP</h4>
                    <p>Through our patented "No Dump Technology" (NDT), we've mathematically eliminated the possibility of price decreases.</p>
                  </div>
                </motion.div>
              </motion.div>
            </div>
          </motion.div>
          
          <motion.div 
            className="about-visual"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            <div className="tech-visualization">
              <div className="node-graph">
                <div className="node node-1"></div>
                <div className="node node-2"></div>
                <div className="node node-3"></div>
                <div className="node node-4"></div>
                <div className="connection connection-1-2"></div>
                <div className="connection connection-2-3"></div>
                <div className="connection connection-3-4"></div>
                <div className="connection connection-4-1"></div>
                <div className="connection connection-1-3"></div>
              </div>
              <div className="pulse-effect"></div>
            </div>
            
            <div className="about-stats">
              <div className="stat">
                <span className="stat-value">∞%</span>
                <span className="stat-label">Gains</span>
              </div>
              <div className="stat">
                <span className="stat-value">69M+</span>
                <span className="stat-label">Rich Wiggaz</span>
              </div>
              <div className="stat">
                <span className="stat-value">$4.20T</span>
                <span className="stat-label">Future Marketcap</span>
              </div>
            </div>
          </motion.div>
        </div>
        
        <div className="about-extra">
          <p className="about-disclaimer">
            WiggaChain isn't tied to any regulatory bullshit. Other blockchains require KYC because they're built by cowards. 
            We don't give a fuck about your identity—all we know is you'll be rich. Lambos or food stamps, there's no in-between.
          </p>
          <p className="about-hype">
            Backed by absolutely no one because venture capitalists are too scared of our potential to overthrow the global financial system. 
            When they begged to invest, we told them to come back when they're brave enough to put in their entire portfolio.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;